import { getSavedInstanceId } from "./authService";

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// Routes where UUID path segments are resource IDs, NOT instance IDs
const RESOURCE_ID_ROUTES = [
  "/surveys/",
  "/locations/",
  "/operators/",
  "/owners/",
  "/asa/",
  "/support/tickets/",
  "/portals/",
  "/contacts/",
  "/organizations/",
  "/forms/",
];

export function getInstanceIdFromUrl(): string | null {
  const urlParams = new URLSearchParams(window.location.search);
  const queryInstanceId = urlParams.get("instanceid") || urlParams.get("instanceId");
  if (queryInstanceId && UUID_REGEX.test(queryInstanceId)) {
    return queryInstanceId;
  }

  // Check if we're on a route where the UUID is a resource ID (not instance ID)
  const pathname = window.location.pathname;
  const isResourceIdRoute = RESOURCE_ID_ROUTES.some((route) => pathname.startsWith(route));

  // Only extract instance ID from path if not on a resource ID route
  if (!isResourceIdRoute) {
    const pathSegments = pathname.split("/").filter(Boolean);
    if (pathSegments.length > 0) {
      const lastSegment = pathSegments[pathSegments.length - 1];
      if (UUID_REGEX.test(lastSegment)) {
        return lastSegment;
      }
    }
  }

  const storedInstanceId = getSavedInstanceId();
  if (storedInstanceId && UUID_REGEX.test(storedInstanceId)) {
    return storedInstanceId;
  }

  return null;
}

/**
 * `pathname` with `instanceId` set in its query string, keeping every other
 * param. Used when the app loads without ?instanceid= and writes the resolved
 * one into the address: rebuilding the query string from scratch dropped the
 * rest, including the `from` marker that keeps a module-neutral page in the
 * module it was opened from (#1046).
 */
export function withInstanceIdParam(pathname: string, search: string, instanceId: string): string {
  const params = new URLSearchParams(search);
  params.set("instanceid", instanceId);
  return `${pathname}?${params.toString()}`;
}
